export default "__VITE_ASSET__Br3UnXbP__"